// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cz2.cz2 .cz2__pets .cz2__pet-pack.cz2__scrollbar-margin-pack{margin-left:32px;margin-right:98px}#cz2.cz2 .cz2__pets .selection-card-list{padding-top:8px;grid-row-gap:40px}#cz2.cz2 .cz2__pets .selection-card-list.cz2__is-kiosk{padding-left:calc(var(--layout-spacing)*2);padding-right:calc(var(--layout-spacing)*2)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
